import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

// The /boot snapshot of variant flags: the variant each one that targets the
// teammate resolves to, by key.
type FeatureFlagVariantsState = Readonly<Record<string, string>>;

const initialState: FeatureFlagVariantsState = {};

const featureFlagVariantsSlice = createSlice({
  name: "featureFlagVariants",
  initialState,
  reducers: {
    setFeatureFlagVariants: (
      _state,
      action: PayloadAction<FeatureFlagVariantsState>,
    ) => action.payload,
  },
});

export const { setFeatureFlagVariants } = featureFlagVariantsSlice.actions;

export const featureFlagVariantsReducer = featureFlagVariantsSlice.reducer;
